import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'delete2FirstChar'
})
export class Delete2FirstCharPipe implements PipeTransform {

  transform(value: string): string {
    return value.substr(2);
  }

}
